import { Box } from '@wix/design-system';
import { CollapseList } from '@wix/rules-panel-ui';
import { useAtom } from 'jotai';
import React, { useMemo } from 'react';
import { openPagesAtom } from '../../../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { PageListItemButton } from '../page-list-item/page-list-item-button-wrapper';
import { PageListItemCollapsible } from '../page-list-item/page-list-item-collapsible-wrapper';
import { CollapseActionsProvider, ItemScopeProvider } from './context/collapse-actions-context';
import { useHandleUnsavedChangesOnToggle } from './utils/use-handle-unsaved-changes-on-toggle';
export const PageList = props => {
  const {
    getGroupData
  } = usePanelStateAtom();
  const [openItems, setOpenItems] = useAtom(openPagesAtom);
  const {
    pageIds
  } = props;
  const isSpecific = props.isSpecificPageList === true;
  const ruleResultsMap = isSpecific ? props.ruleResultsMap : undefined;
  const isAllCrossPageIssuePassed = isSpecific ? props.isAllCrossPageIssuePassed : undefined;
  const handleSetOpenItems = useHandleUnsavedChangesOnToggle(openItems, setOpenItems);
  const pages = useMemo(() => {
    return pageIds.map(pageId => {
      const pageData = getGroupData(pageId);
      if (!pageData) {
        return null;
      }
      const isPageOpen = openItems.has(pageId);
      const pageRuleData = ruleResultsMap == null ? void 0 : ruleResultsMap.get(pageId);
      return pageData.isTpaPage ? /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: pageId,
        key: pageId
      }, /*#__PURE__*/React.createElement(PageListItemButton, {
        isPageOpen: isPageOpen,
        pageId: pageId
      })) : /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: pageId,
        key: pageId
      }, /*#__PURE__*/React.createElement(PageListItemCollapsible, {
        isAllCrossPageIssuePassed: isAllCrossPageIssuePassed,
        isLoading: pageRuleData == null ? void 0 : pageRuleData.isLoading,
        isPageOpen: isPageOpen,
        isSpecificPageList: isSpecific,
        pageId: pageId,
        ruleResults: pageRuleData == null ? void 0 : pageRuleData.ruleResults
      }));
    }).filter(Boolean);
  }, [getGroupData, isAllCrossPageIssuePassed, isSpecific, openItems, pageIds, ruleResultsMap]);
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(CollapseActionsProvider, {
    setOpenItems: handleSetOpenItems
  }, /*#__PURE__*/React.createElement(CollapseList, {
    autoScroll: true,
    contentGap: 0,
    dividerPadding: "0",
    openItems: openItems,
    setOpenItems: handleSetOpenItems
  }, pages)));
};
//# sourceMappingURL=page-list.js.map